import { useNavigate } from "react-router-dom"
import { MobileUserInfoLabel } from "../User"
import './LayoutDesktop.scss'
import { Tracking } from "@/utils/tracking";
import { useRecoilValue } from "recoil";
import { medalRenewedState } from "@/models/honorsState";



export type LayoutDesktopProps = {
    children: React.ReactNode;
    guideOnClick?: () => void;
    honorsOnClick?: () => void;
}


export const LayoutDesktop = ({ children, guideOnClick, honorsOnClick }: LayoutDesktopProps) => {

    const navigate = useNavigate();

    // const showMedalRenewed = useRecoilValue(medalRenewedState)

    const onControlLeft = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        event.stopPropagation()
        if (guideOnClick !== undefined) {
            guideOnClick()
        } else {
            navigate('/guide')
        }
    }

    const onControlRight = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        event.stopPropagation()
        if (honorsOnClick !== undefined) {
            honorsOnClick()
        }else{
            navigate(`/honors/${Math.random()}`)
        }
        Tracking.UP('click_all_answer_glory_button')
    }


    return (
        <div className="desktop-container">
            <div className="desktop-container-content">
                <div className="desktop-container-content-header">
                    <div className="desktop-container-content-header-logo"></div>
                    <MobileUserInfoLabel />
                    <div className="desktop-container-content-header-control">
                        <div className="desktop-container-content-header-control-left pointer" onClick={onControlLeft}></div>
                        <div className="desktop-container-content-header-control-right pointer" onClick={onControlRight}></div>
                        {/* {
                            showMedalRenewed && <p className="desktop-container-content-header-control-medal-text">新成就解锁！</p>
                        } */}
                    </div>
                </div>
                {
                    children
                }
            </div>
        </div>
    )

}

